/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prompt_Tips_Brain_DescInputs */

const es_prompt_tips_brain_desc = /** @type {(inputs: Prompt_Tips_Brain_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activá el modo cerebro (ícono rosa) cuando la consulta sea compleja o requiera razonamiento. Ante la duda, es mejor activarlo.`)
};

const en_prompt_tips_brain_desc = /** @type {(inputs: Prompt_Tips_Brain_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable brain mode (pink icon) when the query is complex or requires reasoning. When in doubt, it's better to enable it.`)
};

/**
* | output |
* | --- |
* | "Enable brain mode (pink icon) when the query is complex or requires reasoning. When in doubt, it's better to enable it." |
*
* @param {Prompt_Tips_Brain_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const prompt_tips_brain_desc = /** @type {((inputs?: Prompt_Tips_Brain_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prompt_Tips_Brain_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prompt_tips_brain_desc(inputs)
	return en_prompt_tips_brain_desc(inputs)
});
export { prompt_tips_brain_desc as "prompt_tips.brain_desc" }